// frontend\src\components\Navbar.js
// import React from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import logo from "../images/G-Law2.png";
// import "../App.css"; // Ensure styles are included

// const Navbar = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   return (
//     <div className={location.pathname === "/" ? "home-background" : ""}>
//       <div className="header-content">
//         <img
//           src={logo}
//           alt="Global Law Guide Logo"
//           className="site-logo"
//           onClick={() => navigate("/")}
//           style={{ cursor: "pointer" }} // Makes it visually clickable
//         />
//         <div className="header-text">
//           <h2 className="header-title">Global Law Hub</h2>
//           <span className="beta-label">Beta Version</span>
//         </div>
//       </div>
//       {children}
//     </div>
//   );
// };

// export default Navbar;


// import React from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import logo from "../images/G-Law2.png";
// import "../App.css"; // Ensure styles are included

// const Navbar = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   return (
//     <div className={location.pathname === "/" ? "home-background" : ""}>
//       <div
//         className="header-content"
//         onClick={() => navigate("/")}
//         style={{ cursor: "pointer" }} // Ensures the whole header looks clickable
//       >
//         <img src={logo} alt="Global Law Guide Logo" className="site-logo" />
//         <div className="header-text">
//           <h2 className="header-title">Global Law Hub</h2>
//           <span className="beta-label">Beta Version</span>
//         </div>
//       </div>
//       {children}
//     </div>
//   );
// };

// export default Navbar;


import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../images/G-Law2.png";
import "../App.css";
import LanguageSelector from "./LanguageSelector";
import NotificationBell from "./consultation/NotificationBell";

// const PROFILE_REMINDER_INTERVAL_MS = 0;
const PROFILE_REMINDER_INTERVAL_MS = 24 * 60 * 60 * 1000; // 24 hours
const REQUIRED_PROFILE_FIELDS = ["firstName", "lastName", "country", "state", "district", "phone"];

const isPresent = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim().length > 0;
  return true;
};

const isProfileComplete = (user) =>
  REQUIRED_PROFILE_FIELDS.every((field) => isPresent(user?.[field]));

const Navbar = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = !!localStorage.getItem("token");

  const [openMenu, setOpenMenu] = useState("");
  const [showPromo, setShowPromo] = useState(true);
  const [promoClosing, setPromoClosing] = useState(false);
  const promoRef = useRef(null);
  const [showProfileReminder, setShowProfileReminder] = useState(false);
  const [profileReminderStorageKey, setProfileReminderStorageKey] = useState("");

  // Responsive state for mobile
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Explore panel (mobile)
  const [exploreOpen, setExploreOpen] = useState(false);

  // Language selector
  const [showLangSelector, setShowLangSelector] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('en');

  // Language popover (mobile) - kept for compatibility
  const [showLang, setShowLang] = useState(false);
  const [langReady, setLangReady] = useState(false);
  
  // Profile dropdown
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileRef = useRef(null);
  
  // Logout confirmation dialog
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  
  const langRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) {
        setShowLang(false);
      }
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => { setShowLang(false); }, [location.pathname]);
  // Try to (re)initialize translate widget when opening popover if it's not mounted yet
  useEffect(() => {
    if (!showLang) return;
    const target = document.getElementById('google_translate_element');
    const tryInit = () => {
      if (!target) return;
      const combo = target.querySelector('.goog-te-combo');
      if (!combo && window.google && window.google.translate) {
        try {
          target.innerHTML = '';
          new window.google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element');
        } catch (_) {}
      }
      const c2 = target.querySelector('.goog-te-combo');
      if (c2) setLangReady(true);
    };
    // slight delay to ensure popover is visible before init
    const t = setTimeout(tryInit, 120);

    // observer to mark ready when widget injects
    if (target) {
      const observer = new MutationObserver(() => {
        const c = target.querySelector('.goog-te-combo');
        if (c) { setLangReady(true); observer.disconnect(); }
      });
      observer.observe(target, { childList: true, subtree: true });
      return () => { clearTimeout(t); observer.disconnect(); };
    }
    return () => clearTimeout(t);
  }, [showLang]);

  // Ensure translate is initialized once script and target exist (safety net)
  useEffect(() => {
    let tries = 0;
    const tryInit = () => {
      const target = document.getElementById('google_translate_element');
      if (target && window.google && window.google.translate) {
        if (!target.querySelector('.goog-te-combo')) {
          try { new window.google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element'); } catch (_) {}
        }
        clearInterval(timer);
      } else if (tries++ > 20) {
        clearInterval(timer);
      }
    };
    const timer = setInterval(tryInit, 300);
    return () => clearInterval(timer);
  }, []);

  const toggleMenu = (key) => {
    setOpenMenu((prev) => (prev === key ? "" : key));
  };

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
    window.location.reload();
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  const closePromo = (e) => {
    if (e) e.stopPropagation();
    setPromoClosing(true);
    // Fallback: in case transitionend doesn't fire
    setTimeout(() => {
      setShowPromo(false);
      setPromoClosing(false);
    }, 400);
  };

  const dismissProfileReminderForDay = () => {
    if (profileReminderStorageKey) {
      localStorage.setItem(profileReminderStorageKey, Date.now().toString());
    }
    setShowProfileReminder(false);
  };

  const handleProfileReminderUpdate = () => {
    dismissProfileReminderForDay();
    navigate("/profile");
  };

  // Active tab for bottom nav
  const activeTab = (() => {
    const p = location.pathname || "";
    if (p === "/") return "home";
    if (/^\/(indian-law|uk-law|us-law|saudi-law|constitution)/.test(p)) return "law";
    if (p.startsWith("/news-information")) return "news";
    if (p.startsWith("/search") || p.startsWith("/other-results") || p.startsWith("/articles")) return "solutions";
    if (p.startsWith("/draft") || p.startsWith("/complaint-drafts") || p.startsWith("/court-drafts")) return "drafts";
    if (p.startsWith("/legal-advisors")) return "advisors";
    return "";
  })();

  const [profilePhoto, setProfilePhoto] = useState(null);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    if (!isLoggedIn) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch('/api/auth/profile', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        const user = data?.user;
        const p = data?.user?.profilePhoto;
        if (p) {
          // Ensure leading slash for static serving; backend sometimes stores with/without
          const normalized = p.startsWith('/') ? p : `/${p}`;
          setProfilePhoto(normalized);
        }
        // Get user name
        if (data?.user?.firstName && data?.user?.lastName) {
          setUserName(`${data.user.firstName} ${data.user.lastName}`);
        } else if (data?.user?.firstName) {
          setUserName(data.user.firstName);
        }

        if (!user) {
          setShowProfileReminder(false);
          return;
        }

        const userKeySeed = user._id || user.emailOrPhone || "anonymous";
        const storageKey = `profileReminderDismissedAt:${userKeySeed}`;
        setProfileReminderStorageKey(storageKey);

        if (isProfileComplete(user)) {
          localStorage.removeItem(storageKey);
          setShowProfileReminder(false);
          return;
        }

        const lastDismissedAt = Number(localStorage.getItem(storageKey) || 0);
        const canShowAgain = !lastDismissedAt || (Date.now() - lastDismissedAt >= PROFILE_REMINDER_INTERVAL_MS);
        
        if (canShowAgain) {
          setTimeout(() => {
            setShowProfileReminder(true);
          }, 5000);
        }
      })
      .catch(() => {
        setShowProfileReminder(false);
      });
  }, [isLoggedIn, location.pathname]);

  return (
    <div className={`app-shell ${location.pathname === "/" ? "home-background" : ""}`}>
      {/* Top promo banner */}
      {/* {showPromo && (
        <div
          ref={promoRef}
          className={`top-promo ${promoClosing ? "closing" : ""}`}
          translate="no"
          onTransitionEnd={() => {
            if (promoClosing) {
              setShowPromo(false);
              setPromoClosing(false);
            }
          }}
        >
          <div className="top-promo-inner">
            <span>Download our Android App Beta Version: </span>
            <a 
              href="/ULJAAPP.apk" 
              download="ULJAAPP.apk"
              onClick={(e) => e.stopPropagation()}
            >
              Download APK
            </a>
          </div>
          <button className="promo-close notranslate" aria-label="Close" onClick={closePromo} translate="no">
            <span className="notranslate" translate="no" aria-hidden="true">✕</span>
          </button>
        </div>
      )} */}

      {/* Main nav bar */}
      <header className={`navbar-h ${isMobile ? "mobile" : ""} notranslate`} translate="no">
        <div className="brand" onClick={() => navigate("/")} translate="yes">
          <img src={logo} alt="ULJAAPP" />
          <span className="beta-badge">BETA Version</span>
        </div>

        {/* Desktop menus */}
        {!isMobile && (
          <nav className="menu" role="navigation" aria-label="Main" translate="yes">
            <div
              className={`menu-item ${openMenu === "products" ? "open" : ""}`}
              onMouseEnter={() => setOpenMenu("products")}
              onMouseLeave={() => setOpenMenu("")}
              onClick={() => toggleMenu("products")}
              translate="yes"
            >
              <button className="menu-btn" translate="yes">Our Services ▾</button>
              <div className="dropdown" translate="yes">
                <button onClick={() => navigate("/services")} translate="yes" style={{fontWeight: 'bold', borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', marginBottom: '5px'}}>Services Overview</button>
                <button onClick={() => navigate("/search")} translate="yes">Find Your Solutions</button>
                <button onClick={() => navigate("/draft-create")} translate="yes">Create Draft</button>
                <button onClick={() => navigate("/contribute")} translate="yes">Contribute</button>
                <button onClick={() => navigate("/document-reader")} translate="yes">Document Reader</button>
              </div>
            </div>

            <div
              className={`menu-item ${openMenu === "judiciary" ? "open" : ""}`}
              onMouseEnter={() => setOpenMenu("judiciary")}
              onMouseLeave={() => setOpenMenu("")}
              onClick={() => toggleMenu("judiciary")}
            >
              <button className="menu-btn">Judiciary ▾</button>
              <div className="dropdown">
                <button onClick={() => navigate("/indian-law")}>Indian Law</button>
                <button onClick={() => navigate("/uk-law")}>United Kingdom Law</button>
                <button onClick={() => navigate("/us-law")}>American Law</button>
                <button onClick={() => navigate("/saudi-law")}>Saudi Law</button>
              </div>
            </div>

            <div
              className={`menu-item ${openMenu === "advisors" ? "open" : ""}`}
              onMouseEnter={() => setOpenMenu("advisors")}
              onMouseLeave={() => setOpenMenu("")}
              onClick={() => toggleMenu("advisors")}
            >
              <button className="menu-btn">Legal Advisors ▾</button>
              <div className="dropdown">
                <button onClick={() => navigate("/legal-advisors")}>Find Advisors</button>
                {/* <button onClick={() => navigate("/become-legal-advisor")}>Become an Advisor</button> */}
              </div>
            </div>

            <div
              className={`menu-item ${openMenu === "company" ? "open" : ""}`}
              onMouseEnter={() => setOpenMenu("company")}
              onMouseLeave={() => setOpenMenu("")}
              onClick={() => toggleMenu("company")}
            >
              <button className="menu-btn">Company ▾</button>
              <div className="dropdown">
                <button onClick={() => navigate("/about")}>About</button>
                <button onClick={() => navigate("/feedback")}>Feedback</button>
                <button onClick={() => navigate("/privacy-policy")}>Privacy Policy</button>
                <button onClick={() => navigate("/terms-of-service")}>Terms of Service</button>
              </div>
            </div>

            <div
              className={`menu-item ${openMenu === "news" ? "open" : ""}`}
              onMouseEnter={() => setOpenMenu("news")}
              onMouseLeave={() => setOpenMenu("")}
              onClick={() => toggleMenu("news")}
            >
              <button className="menu-btn">News & Info ▾</button>
              <div className="dropdown">
                <button onClick={() => navigate("/news-information")}>News</button>
                <button onClick={() => navigate("/articles")}>Articles</button>
              </div>
            </div>

            <div className="menu-item" onClick={() => navigate("/pricing")}> 
              <button className="menu-btn">Pricing</button>
            </div>
          </nav>
        )}

        {/* Right side (always visible) */}
        <div className="nav-right">
          {/* Language selector button */}
          <button
            className="lang-selector-btn"
            onClick={() => setShowLangSelector(true)}
            title="Select Language"
          >
            <span className="lang-icon notranslate" translate="no">🌐</span>
            <span className="lang-text notranslate" translate="no">Select Language</span>
          </button>

          {/* Hidden Google Translate widget for functionality */}
          <div style={{ display: 'none' }}>
            <div id="google_translate_element"></div>
          </div>

          {isLoggedIn ? (
            <>
              <NotificationBell />
              {/* On mobile, hide the Logout button (available inside Explore). Keep it on desktop. */}
              {!isMobile && (
                <div className="profile-menu-container" ref={profileRef}>
                  <div 
                    className="avatar" 
                    title="Profile" 
                    onClick={() => setShowProfileMenu(!showProfileMenu)}
                  >                
                    <img src={profilePhoto || "/default-profile.png"} alt="profile" />
                  </div>
                  {showProfileMenu && (
                    <div className="profile-dropdown">
                      <div className="profile-dropdown-header">
                        <div className="profile-dropdown-avatar">
                          <img src={profilePhoto || "/default-profile.png"} alt="profile" />
                        </div>
                        <span className="profile-dropdown-name notranslate" translate="no">{userName}</span>
                      </div>
                      <div className="profile-dropdown-divider"></div>
                      <button onClick={() => { setShowProfileMenu(false); navigate("/profile"); }}>
                        <span className="profile-menu-icon notranslate" translate="no" aria-hidden="true">👤</span>
                        <span>Profile</span>
                      </button>
                      <button className="logout-item" onClick={() => { setShowProfileMenu(false); handleLogout(); }}>
                        <span className="profile-menu-icon notranslate" translate="no" aria-hidden="true">➡️</span>
                        <span>Logout</span>
                      </button>
                    </div>
                  )}
                </div>
              )}
              {isMobile && (
                <div className="avatar" title="Profile" onClick={() => navigate("/profile")}>                
                  <img src={profilePhoto || "/default-profile.png"} alt="profile" />
                </div>
              )}
            </>
          ) : (
            <button className="btn-login" onClick={() => navigate("/login")}>Login</button>
          )}
        </div>
      </header>

      {/* Reserves the space taken by the fixed navbar so content isn't hidden. */}
      <div className="navbar-spacer" aria-hidden="true"></div>

      {isLoggedIn && showProfileReminder && (
        <div className="profile-reminder-banner" role="alert" aria-live="polite">
          <div className="profile-reminder-message">
            <span className="profile-reminder-icon notranslate" translate="no" aria-hidden="true">⚠️</span>
            <span>Update your profile for better results</span>
          </div>
          <div className="profile-reminder-actions">
            <button className="profile-reminder-update-btn" onClick={handleProfileReminderUpdate}>Update Profile</button>
            <button
              className="profile-reminder-close-btn notranslate"
              onClick={dismissProfileReminderForDay}
              aria-label="Dismiss profile update reminder"
              translate="no"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* page content */}
      <div style={{ paddingBottom: isMobile ? 64 : 0 }}>
        {children}
      </div>

      {/* Bottom navigation for mobile */}
      {isMobile && (
        <>
          <nav className="bottom-nav notranslate" role="navigation" aria-label="Primary" translate="no">
            <button className={activeTab === "home" ? "active" : ""} onClick={() => navigate("/")}>              
              <span className="icon notranslate" translate="no" aria-hidden="true">🏠</span>
              <span>Home</span>
            </button>
            <button className={activeTab === "news" ? "active" : ""} onClick={() => navigate("/news-information")}>              
              <span className="icon notranslate" translate="no" aria-hidden="true">📰</span>
              <span>News</span>
            </button>
            <button className={activeTab === "solutions" ? "active" : ""} onClick={() => navigate("/search")}>              
              <span className="icon notranslate" translate="no" aria-hidden="true">🔎</span>
              <span>Solutions</span>
            </button>
            <button className={activeTab === "drafts" ? "active" : ""} onClick={() => navigate("/draft-create")}>              
              <span className="icon notranslate" translate="no" aria-hidden="true">✍️</span>
              <span>Draft</span>
            </button>
            <button className={activeTab === "advisors" ? "active" : ""} onClick={() => navigate("/legal-advisors")}>              
              <span className="icon notranslate" translate="no" aria-hidden="true">👨‍⚖️</span>
              <span>Advisors</span>
            </button>
            <button className={activeTab === "explore" ? "active" : ""} onClick={() => setExploreOpen(true)}>              
              <span className="icon notranslate" translate="no" aria-hidden="true">☰</span>
              <span>Explore</span>
            </button>
          </nav>

          {exploreOpen && (
            <div className="explore-overlay" onClick={() => setExploreOpen(false)}>
              <div className="explore-panel" onClick={(e) => e.stopPropagation()}>
                <div className="explore-head">
                  <h3>Explore Menu</h3>
                  <button className="close notranslate" aria-label="Close" onClick={() => setExploreOpen(false)} translate="no">
                    <span className="notranslate" translate="no" aria-hidden="true">✕</span>
                  </button>
                </div>
                
                {/* Main Navigation Section */}
                <div className="explore-section">
                  <div className="explore-grid">
                    <button onClick={() => { setExploreOpen(false); navigate("/services"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">⭐</span>
                      <em>Our Services</em>
                    </button>
                    <button onClick={() => { setExploreOpen(false); navigate("/document-reader"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">📄</span>
                      <em>Document Reader</em>
                    </button>
                    <button onClick={() => { setExploreOpen(false); navigate("/indian-law"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">⚖️</span>
                      <em>Law</em>
                    </button>
                    <button onClick={() => { setExploreOpen(false); navigate("/articles"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">📚</span>
                      <em>Publications</em>
                    </button>
                  </div>
                </div>

                {/* Information & Support Section */}
                <div className="explore-section">
                  <div className="section-label">Information & Support</div>
                  <div className="explore-grid">
                    <button onClick={() => { setExploreOpen(false); navigate("/about"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">ℹ️</span>
                      <em>About</em>
                    </button>
                    <button onClick={() => { setExploreOpen(false); navigate("/pricing"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">💳</span>
                      <em>Pricing</em>
                    </button>
                    <button onClick={() => { setExploreOpen(false); navigate("/feedback"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">✉️</span>
                      <em>Feedback</em>
                    </button>
                  </div>
                </div>

                {/* Professional Section */}
                <div className="explore-section">
                  <div className="section-label">For Professionals</div>
                  <div className="explore-grid explore-grid-single">
                    <button onClick={() => { setExploreOpen(false); navigate("/become-legal-advisor"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">👔</span>
                      <em>Become Legal Advisor</em>
                    </button>
                  </div>
                </div>

                {/* Legal Section */}
                <div className="explore-section">
                  <div className="section-label">Legal & Policies</div>
                  <div className="explore-grid">
                    <button onClick={() => { setExploreOpen(false); navigate("/privacy-policy"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">🔒</span>
                      <em>Privacy Policy</em>
                    </button>
                    <button onClick={() => { setExploreOpen(false); navigate("/terms-of-service"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">📋</span>
                      <em>Terms of Service</em>
                    </button>
                  </div>
                </div>

                {/* Account Section */}
                <div className="explore-section explore-section-account">
                  {!isLoggedIn ? (
                    <button className="explore-btn-full" onClick={() => { setExploreOpen(false); navigate("/login"); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">🔐</span>
                      <em>Login to Your Account</em>
                    </button>
                  ) : (
                    <button className="explore-btn-full explore-btn-logout" onClick={() => { setExploreOpen(false); handleLogout(); }}>
                      <span className="explore-icon notranslate" translate="no" aria-hidden="true">🚪</span>
                      <em>Logout</em>
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* Scoped styles to avoid touching other files */}
      <style>{`
        /* Global reset to remove unwanted gaps and ensure full-bleed */
        *, *::before, *::after { box-sizing: border-box; }
        html, body { margin: 0 !important; padding: 0 !important; width: 100%; max-width: 100vw; overflow-x: hidden; }
        #root { width: 100%; max-width: 100vw; overflow-x: hidden; }

        /* Ensure top bars never overflow the viewport */
        .navbar-h { width: 100%; max-width: 100vw; box-sizing: border-box; }
        .top-promo { width: 100%; max-width: 100vw; box-sizing: border-box; }

        .profile-reminder-banner {
          position: fixed;
          top: 60px;
          left: 0;
          right: 0;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          background: #f2efe6;
          border: 1px solid #decfa4;
          border-left: 0;
          border-right: 0;
          padding: 4px 10px;
          color: #7a5200;
          z-index: 99;
          min-width: 0;
          min-height: 30px;
        }
        .profile-reminder-message {
          display: flex;
          align-items: center;
          gap: 6px;
          font-weight: 700;
          font-size: 13px;
          line-height: 1;
          flex: 1;
          min-width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 22px;
        }
        .profile-reminder-icon {
          font-size: 14px;
          line-height: 1;
        }
        .profile-reminder-actions {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          flex-shrink: 0;
          height: 22px;
        }
        .profile-reminder-update-btn {
          border: none;
          border-radius: 6px;
          background: #f29f05;
          color: #fff;
          padding: 0 9px;
          font-size: 12px;
          line-height: 1;
          white-space: nowrap;
          font-weight: 700;
          cursor: pointer;
          height: 22px;
          display: inline-flex;
          align-items: center;
          position: relative;
          top: -10px;
        }
        .profile-reminder-update-btn:hover {
          background: #e08f00;
        }
        .profile-reminder-close-btn {
          border: none;
          background: transparent;
          color: #936300;
          font-size: 16px;
          line-height: 1;
          cursor: pointer;
          padding: 0 2px;
          white-space: nowrap;
          height: 22px;
          width: 18px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          position: relative;
          top: -10px;
        }

        @media (max-width: 768px) {
          .profile-reminder-banner {
            flex-wrap: nowrap;
            padding: 3px 8px;
            min-height: 28px;
          }
          .profile-reminder-message {
            font-size: 12px;
            height: 20px;
          }
          .profile-reminder-actions {
            justify-content: flex-end;
            height: 20px;
          }
          .profile-reminder-update-btn {
            padding: 0 8px;
            font-size: 11px;
            height: 20px;
            top: -10px;
          }
          .profile-reminder-close-btn {
            font-size: 14px;
            height: 20px;
            width: 16px;
            top: -10px;
          }
        }

        /* Mobile top bar overrides */
        .navbar-h.mobile {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 3000; /* ensure above content */
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 10px;
          background: #0f2a60;
          color: #fff;
          border-bottom: 1px solid rgba(255,255,255,0.15);
          width: 100%;
          max-width: 100vw;
          box-sizing: border-box;
        }
        .navbar-h.mobile .menu { display: none; }
        .navbar-h.mobile .brand img { width: 150px; height: 55px; border-radius: 30px; padding: 0; object-fit: contain; display: block; }
        .navbar-h.mobile .brand span { font-weight: 700; font-size: 18px; }
        .navbar-h.mobile .nav-right { gap: 6px; display: flex; align-items: center; }
        .navbar-h.mobile .btn-login, .navbar-h.mobile .btn-logout { padding: 6px 10px; }
        .navbar-h.mobile .avatar { width: 42px; height: 42px; margin-right: 10px; margin-left: 0; }
        .navbar-h.mobile .nav-translate { min-width: auto; }

        /* Language (icon -> popover on mobile) */
        .navbar-h.mobile .lang-container { position: relative; }
        .navbar-h.mobile .lang-btn { background: #0b1f4a; color:#fff; border: 1px solid rgba(255,255,255,.25); padding: 6px 8px; border-radius: 8px; font-size: 16px; line-height: 1; cursor: pointer; margin-bottom: 25px; }
        /* Use collapse instead of display:none so Google can render inside */
        .navbar-h.mobile .lang-popover { position: absolute; right: 0; top: 120%; background: #fff; color: #123; border-radius: 10px; box-shadow: 0 10px 24px rgba(0,0,0,.2); padding: 8px; z-index: 5000; min-width: 240px; max-height: 0; opacity: 0; overflow: hidden; pointer-events: none; transform: translateY(-2px) scale(.98); transition: all .18s ease; }
        .navbar-h.mobile .lang-container.open .lang-popover { max-height: 360px; opacity: 1; pointer-events: auto; transform: translateY(0) scale(1); }
        /* Ensure the select is visible and fills width */
        .lang-popover #google_translate_element { display: block; }
        .lang-popover .goog-te-gadget { display: block !important; }
        .lang-popover .goog-te-combo { width: 100% !important; font-size: 14px; padding: 6px 8px; }
        .lang-loading { font-size: 12px; color: #456; padding-top: 4px; }

        /* Desktop language inline and avoid extra space */
        @media (min-width: 769px) {
          .lang-container .lang-btn { display: none; }
          .lang-container .lang-popover { max-height: none; opacity: 1; pointer-events: auto; position: static; background: transparent; box-shadow: none; padding: 0; transform: none; min-width: 180px; }
          .lang-loading { display: none !important; }
        }

        /* Bottom navigation */
        .bottom-nav {
          position: fixed;
          left: 0; right: 0; bottom: 0;
          height: 58px;
          background: #0f2a60;
          border-top: 1px solid rgba(255,255,255,.15);
          display: flex;
          align-items: center;
          justify-content: space-around;
          z-index: 2500;
          width: 100%;
          max-width: 100vw;
          box-sizing: border-box;
        }
        .bottom-nav button {
          background: transparent;
          color: #fff;
          border: none;
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          gap: 2px;
          font-size: 11px;
          padding: 4px 6px;
          cursor: pointer;
          position: relative; /* added */
          top: -10px; /* lift icons a little */
        }
        .bottom-nav .icon { font-size: 18px; line-height: 18px; }
        .bottom-nav button.active { color: #4dd0e1; }

        /* Raise logout button slightly */
        .nav-right .btn-logout { position: relative; }
        .navbar-h.mobile .btn-logout { top: -3px; }

        /* Explore overlay */
        .explore-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.5); backdrop-filter: blur(4px); z-index: 2600; display: flex; justify-content: center; align-items: flex-start; padding-top: 60px; }
        .explore-panel { width: 92%; max-width: 480px; background: #fff; border-radius: 16px; padding: 20px; box-shadow: 0 12px 40px rgba(0,0,0,.3); max-height: 80vh; overflow-y: auto; }
        .explore-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; padding-bottom: 14px; border-bottom: 2px solid #e5e8f2; }
        .explore-head h3 { margin: 0; color: #14305e; font-size: 22px; font-weight: 700; }
        .explore-head .close { background: #f0f2f8; border: none; font-size: 20px; cursor: pointer; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: all 0.2s; }
        .explore-head .close:hover { background: #e0e4f0; transform: rotate(90deg); }
        
        /* Section styling */
        .explore-section { margin-bottom: 16px; }
        .explore-section:last-child { margin-bottom: 0; }
        .section-label { font-size: 11px; font-weight: 700; text-transform: uppercase; color: #7a8aaa; margin-bottom: 8px; padding-left: 4px; letter-spacing: 0.5px; }
        
        /* Grid layouts */
        .explore-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
        .explore-grid-single { grid-template-columns: 1fr; }
        
        /* Button styling */
        .explore-grid button { background: #f7f9fc; border: 1px solid #e0e5f2; border-radius: 12px; padding: 16px 12px; display: flex; flex-direction: column; align-items: center; gap: 8px; cursor: pointer; color: #0f2a5a; transition: all 0.2s; }
        .explore-grid button:hover { background: #eef3ff; border-color: #c8d4f5; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(15, 42, 90, 0.1); }
        .explore-grid button:active { transform: translateY(0); }
        .explore-icon { font-size: 28px; line-height: 1; overflow: hidden; position: relative; }
        .explore-grid button em { font-style: normal; font-weight: 600; font-size: 14px; text-align: center; line-height: 1.3; }
        /* Hide Google Translate injected font tags in mobile icons */
        .explore-icon font,
        .explore-head .close font,
        .bottom-nav .icon font,
        .profile-menu-icon font,
        .promo-close font {
          display: none !important;
          visibility: hidden !important;
          position: absolute !important;
          left: -9999px !important;
          width: 0 !important;
          height: 0 !important;
          overflow: hidden !important;
        }
        .explore-head .close { overflow: hidden; position: relative; }
        .bottom-nav button { overflow: hidden; position: relative; }
        .profile-menu-icon { overflow: hidden; position: relative; display: inline-block; }
        .promo-close { overflow: hidden; position: relative; }
        
        /* Full-width buttons for account section */
        .explore-section-account { margin-top: 20px; padding-top: 16px; border-top: 2px solid #e5e8f2; }
        .explore-btn-full { width: 100%; background: #162d66; border: none; border-radius: 12px; padding: 14px 16px; display: flex; align-items: center; justify-content: center; gap: 10px; cursor: pointer; color: #fff; transition: all 0.2s; }
        .explore-btn-full:hover { background: #1e3a86; transform: translateY(-2px); box-shadow: 0 6px 16px rgba(22, 45, 102, 0.3); }
        .explore-btn-full .explore-icon { font-size: 20px; }
        .explore-btn-full em { font-style: normal; font-weight: 600; font-size: 15px; }
        .explore-btn-logout { background: #dc3545; }
        .explore-btn-logout:hover { background: #c82333; }

        @media (min-width: 769px) { .bottom-nav, .explore-overlay { display: none; } }

        /* Logout Confirmation Dialog Styles */
        .logout-confirmation-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 10000;
        }

        .logout-confirmation-dialog {
          background: white;
          border-radius: 12px;
          padding: 0;
          max-width: 400px;
          width: 90%;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          animation: slideInFromTop 0.3s ease-out;
        }

        .logout-confirmation-header {
          background: linear-gradient(135deg, #162d66 0%, #1e3a86 100%);
          color: white;
          padding: 25px 20px 20px;
          border-radius: 12px 12px 0 0;
          text-align: center;
        }

        .logout-icon {
          font-size: 2.5rem;
          margin-bottom: 10px;
          animation: wave 2s infinite;
        }

        @keyframes wave {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-10deg); }
          75% { transform: rotate(10deg); }
        }

        .logout-confirmation-header h3 {
          margin: 0;
          font-size: 1.4rem;
          font-weight: 600;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }

        .logout-confirmation-body {
          padding: 25px 20px;
          text-align: center;
        }

        .logout-confirmation-body p {
          margin: 0 0 10px 0;
          color: #333;
          font-size: 1.1rem;
          line-height: 1.5;
          font-weight: 500;
        }

        .logout-subtitle {
          color: #666 !important;
          font-size: 0.95rem !important;
          font-style: italic;
          font-weight: 400 !important;
          margin-bottom: 0 !important;
        }

        .logout-confirmation-actions {
          display: flex;
          gap: 12px;
          padding: 0 20px 20px;
          justify-content: center;
        }

        .logout-cancel-btn, .logout-confirm-btn {
          padding: 14px 20px;
          border: none;
          border-radius: 10px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .logout-cancel-btn {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          color: #495057;
          border: 2px solid #dee2e6;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .logout-cancel-btn:hover {
          background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
          color: #343a40;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .logout-confirm-btn {
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
          color: white;
          box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
        }

        .logout-confirm-btn:hover {
          background: linear-gradient(135deg, #c82333 0%, #a71e2a 100%);
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
        }

        .logout-cancel-btn span, .logout-confirm-btn span {
          font-size: 1.1rem;
        }

        @keyframes slideInFromTop {
          from {
            opacity: 0;
            transform: translateY(-50px) scale(0.8);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        /* Mobile responsiveness for logout dialog */
        @media (max-width: 480px) {
          .logout-confirmation-dialog {
            width: 95%;
            margin: 20px;
          }
          
          .logout-confirmation-header {
            padding: 20px 15px 15px;
          }

          .logout-icon {
            font-size: 2rem;
            margin-bottom: 8px;
          }
          
          .logout-confirmation-header h3 {
            font-size: 1.2rem;
          }
          
          .logout-confirmation-body {
            padding: 20px 15px;
          }
          
          .logout-confirmation-body p {
            font-size: 1rem;
          }

          .logout-subtitle {
            font-size: 0.9rem !important;
          }
          
          .logout-confirmation-actions {
            flex-direction: column;
            padding: 0 15px 20px;
            gap: 12px;
          }
          
          .logout-cancel-btn, .logout-confirm-btn {
            width: 100%;
            padding: 16px;
            min-width: auto;
          }

          .logout-cancel-btn span, .logout-confirm-btn span {
            font-size: 1rem;
          }
        }
      `}</style>

      {/* Custom Language Selector Modal */}
      <LanguageSelector 
        isOpen={showLangSelector}
        onClose={() => setShowLangSelector(false)}
        currentLang={currentLanguage}
      />

      {/* Logout Confirmation Dialog */}
      {showLogoutConfirm && (
        <div className="logout-confirmation-overlay">
          <div className="logout-confirmation-dialog">
            <div className="logout-confirmation-header">
              <div className="logout-icon">👋</div>
              <h3>See You Soon!</h3>
            </div>
            <div className="logout-confirmation-body">
              <p>Are you sure you want to take a break from your legal journey with us today?</p>
              <p className="logout-subtitle">Your progress and contributions are always saved.</p>
            </div>
            <div className="logout-confirmation-actions">
              <button className="logout-cancel-btn" onClick={cancelLogout}>
                <span className="notranslate" translate="no">✨</span> Stay Connected
              </button>
              <button className="logout-confirm-btn" onClick={confirmLogout}>
                <span className="notranslate" translate="no">🚪</span> Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
